export const enum Theme {
  Light = 0,
  Dark = 1,
  Auto = 2,
}
